export default __webpack_public_path__ + "static/media/cole-farm-counter.2032ed2e.jpg";